import { FONT_WEIGHT } from '../../../foundations/typography';
import { PopoverVariantType } from '../../popover/variants';
import { TextVariantType } from '../../text/variants';
import { ActionBottomSheetVariantType } from '../variants';
const getBoxShadow = (FOUNDATIONS) => {
    // SHADOW_40
    return `0 ${FOUNDATIONS.spacing_75} ${FOUNDATIONS.spacing_100} ${FOUNDATIONS.spread_negative_50} ${FOUNDATIONS.color_effect_shadow_drop_100}`;
};
export const getInputSearchStyles = (FOUNDATIONS, FONT) => {
    return {
        [ActionBottomSheetVariantType.INPUT_SEARCH]: {
            popoverVariant: PopoverVariantType.ACTION_BOTTOM_SHEET,
            container: {
                width: '100%',
                background_color: FOUNDATIONS.color_exception_neutral_bg_850,
                box_shadow: getBoxShadow(FOUNDATIONS),
                display: 'flex',
                flex_direction: 'column',
                overflow_y: 'auto',
                border_top_left_radius: FOUNDATIONS.radius_comp_containers_modal_topradius_radiussize,
                border_top_right_radius: FOUNDATIONS.radius_comp_containers_modal_topradius_radiussize,
            },
            controlContainer: {
                padding: `${FOUNDATIONS.spacing_150} ${FOUNDATIONS.spacing_250} ${FOUNDATIONS.spacing_250} ${FOUNDATIONS.spacing_250}`,
            },
            dragIcon: {
                width: FOUNDATIONS.size_350,
                height: FOUNDATIONS.size_50,
                color: FOUNDATIONS.color_neutral_bg_onsurface_65,
            },
            closeIconContainer: {
                justify_content: 'flex-end',
                margin_bottom: FOUNDATIONS.spacing_100,
            },
            closeIcon: {
                width: FOUNDATIONS.size_250,
                height: FOUNDATIONS.size_250,
                color: FOUNDATIONS.color_neutral_icon_50,
            },
            header: {
                display: 'flex',
                flex_direction: 'column',
                box_shadow: FOUNDATIONS.color_effect_shadow_drop_50,
                padding: `0 ${FOUNDATIONS.spacing_250} ${FOUNDATIONS.spacing_250} ${FOUNDATIONS.spacing_250}`,
            },
            titleContainer: {
                margin_bottom: FOUNDATIONS.spacing_250,
            },
            titleContainerFont: {
                text_align: 'center',
            },
            title: {
                font_variant: TextVariantType.FONT_PARAGRAPH_200,
                font_weight: FONT_WEIGHT.font_bold,
                color: FOUNDATIONS.color_neutral_font_50,
            },
            content: {
                max_height: '100vh',
                overflow_y: 'auto',
            },
        },
    };
};
//# sourceMappingURL=inputSearch.js.map